export default __webpack_public_path__ + "static/media/gallery-wip-emitter-tip_07.1b342105.jpg";